<template>
  <div class="home-view">
    <div v-if="!loadingUser" class="login-provider-google">
      <component
        is="script"
        src="https://accounts.google.com/gsi/client"
        async
        v-if="googleClientID"
        @load="initSignIn"
      />
      <div v-if="googleClientID && !auth_user" id="gSignInButton" />
    </div>
    <RefundCredits :creditReferences="creditReference"></RefundCredits>

    <div class="home-slider-wrapper">
      <home-slider></home-slider>
    </div>

    <section class="best-seller boxes-container bb-new-container">
      <div class="full-width">
        <div class="boxes-title">
          <span class="typography-title-medium">Lo más regalado</span>
          <router-link
            class="typography-action-small bb-underline bb-ml-1 bb-my-1"
            :to="{
              name: 'products',
              query: {
                card: 0,
              },
            }"
          >
            Ver más
          </router-link>
        </div>
        <bb-horizontal-slider
          v-if="!$apollo.queries.featured_boxes.loading"
          :items="featuredBoxList"
          itemClass="withPadding col-xs-8 col-sm-4 col-md-3 col-lg-3 bb-mb-1"
          :bigItem="true"
          arrowClass="boxBlockArrow"
          style="padding-left: 8px !important; padding-right: 8px !important"
        >
          <box-card slot="item" slot-scope="props" :box="props.item" />
        </bb-horizontal-slider>
        <div
          v-else
          class="bb-row full-width bb-justify-content-between skeleton-row"
        >
          <product-block-skeleton
            class="full-width col-xs-8 col-sm-4 col-md-3 col-lg-3 bb-mb-1"
            v-for="box in 4"
            coverPaddingBottom="86"
          ></product-block-skeleton>
        </div>
      </div>
    </section>

    <!-- CATEGORIES BOX ACTIVITIES -->
    <section class="featured-activities boxes-container bb-new-container">
      <div
        v-if="featuredActivities"
        class="full-width"
        v-for="category in featuredActivities"
      >
        <div class="boxes-title">
          <span class="typography-title-medium">{{
            category.home_carousel_title
              ? category.home_carousel_title
              : `Destacados de ${category.name}`
          }}</span>
          <router-link
            class="typography-action-small bb-underline bb-ml-1 bb-my-1"
            :to="{
              name: 'products',
              query: {
                card: 0,
                filters: JSON.stringify({ boxCategory: category.name }),
              },
            }"
          >
            Ver más
          </router-link>
        </div>
        <bb-horizontal-slider
          :items="category.activities"
          itemClass="withPadding col-xs-8 col-sm-4 col-md-3 col-lg-3 bb-mb-1"
          :bigItem="true"
          arrowClass="boxBlockArrow"
          style="padding-left: 8px !important; padding-right: 8px !important"
        >
          <box-card
            slot="item"
            slot-scope="props"
            :box="props.item"
            :category="category"
          />
        </bb-horizontal-slider>
      </div>
      <div v-if="!categories">
        <div class="boxes-title">
          <p class="typography-title-medium">Destacados</p>
        </div>
        <div
          v-for="i in 6"
          class="bb-row full-width bb-justify-content-between skeleton-row"
        >
          <product-block-skeleton
            class="full-width col-xs-8 col-sm-4 col-md-3 col-lg-3 bb-mb-1"
            v-for="box in 4"
            coverPaddingBottom="86"
          ></product-block-skeleton>
        </div>
      </div>
    </section>

    <!-- SOLO EN BIGBOX -->
    <section
      v-if="onlyOnBigboxContent.length > 0"
      class="featured-activities boxes-container bb-new-container"
    >
      <div class="boxes-title">
        <span class="typography-title-medium">Solo en Bigbox</span>
        <router-link
          class="typography-action-small bb-underline bb-ml-1 bb-my-1"
          :to="{
            name: 'new-custom-landing',
            params: { landingSlug: `solo-en-bigbox-${tld}` },
          }"
        >
          Ver más
        </router-link>
      </div>
      <bb-horizontal-slider
        :items="onlyOnBigboxContent"
        itemClass="withPadding col-xs-8 col-sm-4 col-md-3 col-lg-3 bb-mb-1"
        :bigItem="true"
        arrowClass="boxBlockArrow"
        style="padding-left: 8px !important; padding-right: 8px !important"
      >
        <box-card
          slot="item"
          slot-scope="props"
          :box="props.item"
          :category="props.item.category"
        />
      </bb-horizontal-slider>
    </section>

    <div class="full-width bb-fcenter bb-mt-3">
      <router-link
        class="see-all-button bb-button --primary bb-bold bb-px-3 full-width bb-fcenter"
        :to="{ name: 'products', query: { card: 0 } }"
      >
        Ver todas
      </router-link>
    </div>
    <section
      v-if="categories"
      class="categories-cards boxes-container bb-new-container"
    >
      <div class="full-width">
        <div class="boxes-title">
          <span class="typography-title-medium">Categorías</span>
        </div>
        <bb-horizontal-slider
          v-if="categories"
          :items="categories"
          itemClass="withPadding categories bb-mb-1"
          arrowClass="boxBlockArrow"
          style="padding-left: 8px !important; padding-right: 8px !important"
        >
          <category-card
            slot="item"
            slot-scope="props"
            @blockClicked="redirectToFilters(props.item.name)"
            :title="props.item.name"
            :image="props.item.home_carousel_image"
          >
          </category-card>
        </bb-horizontal-slider>
      </div>
    </section>
    <!-- BbPlus banner -->
    <section class="bb-new-container boxes-container" v-show="showBBPlusBanner">
      <div class="bb-plus-banner">
        <div class="img-container">
          <img src="../../assets/images/BbPlusBanner.png" class="img" />
          <span
            class="bb-plus-logo"
            v-html="require('assets/icons/BbPlusLogo.svg')"
          ></span>
        </div>
        <div class="content">
          <span class="title">{{ bbPlusBanner.title }}</span>
          <span class="subtitle">{{ bbPlusBanner.subtitle }}</span>
          <span class="description">{{ bbPlusBanner.description }}</span>
          <router-link
            :to="{
              name: 'new-custom-landing',
              params: {
                landingSlug: bbPlusBanner.ctaLandingSlug,
              },
            }"
            :tag="button"
            class="cta bb-button --bb-plus"
          >
            {{ bbPlusBanner.cta }}
          </router-link>
        </div>
      </div>
    </section>

    <section class="cards-container bb-new-container bb-column bb-mt-8">
      <div class="bb-row-to-column">
        <template v-for="card in homeCards">
          <home-card
            :title="card.title"
            :description="card.description"
            :cta="card.cta"
            :goTo="card.goTo"
            :icon="card.icon"
          ></home-card>
        </template>
      </div>
      <div
        class="bb-row corporate-card bb-justify-content-center"
        :style="{
          backgroundImage:
            'url(' + require('assets/images/corporate-card-pattern.png') + ')',
        }"
      >
        <div class="bb-column bb-justify-content-center corporate-card-column">
          <span
            class="hands-icon"
            v-html="require('assets/icons/hands.svg')"
          ></span>
        </div>
        <div class="bb-column bb-justify-content-center corporate-card-column">
          <div class="bb-row-to-column">
            <div class="corporate-card-description">
              <h1 class="figtree-font bb-semi-bold bb-mb-1 bb-text-white">
                {{ $translate('Hacé') }} un regalo empresarial
              </h1>
              <span class="bb-sm-max-pr-3 bb-description-3 bb-text-white">
                {{ $translate('Fidelizá') }} clientes y colaboradores con
                Bigbox, hacer un regalo nunca fue tan fácil.
              </span>
            </div>
            <div class="bb-column bb-justify-content-center">
              <a
                class="bb-button --white --withBorder bb-bold bb-py-1 bb-px-6 bb-sm-max-p-0 bb-text-primary"
                :href="corpoUrl"
              >
                {{
                  $screen.width > 768
                    ? desktopBussinessCardText
                    : mobileBussinessCardText
                }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div
      v-if="isSafari && !toolTipState"
      class="tooltip full-width bb-px-2 bb-py-1 bb-show-xs-min"
    >
      <div class="tip bb-row">
        <div class="bb-row bb-justify-content-center bb-align-items-center">
          <span
            class="more-icon"
            v-html="require('assets/icons/mas.svg')"
          ></span>

          <p class="bb-description-2 bb-ml-1">
            {{ $translate('Instalá') }} esta app en tu iPhone:
            <span
              class="tap-icon"
              v-html="require('assets/icons/tap.svg')"
            ></span>
            {{ $translate('tocá') }} y {{ $translate('añadilo') }} a tu pantalla
            de inicio
          </p>
        </div>

        <div class="bb-text-right">
          <span @click="closeToolTip()" class="bb-cursor-pointer">x</span>
        </div>
      </div>
    </div>
    <div class="news-container bb-fcenter">
      <news-letter-subscription
        :description="`${this.$translate('Suscribite')} a nuestras novedades!`"
        :inputSize="'--large'"
        disclaimer
      />
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import Component from 'vue-class-component';

  import requests from 'common/services/requests';
  import { getCorpoUrl } from 'common/utils/getCorpoUrl';
  import getLastTld from 'common/services/utils/getLastTld';
  import { getCountryNameFromTld } from 'common/services/getLastTld';
  import onlyOnBigBoxService from 'services/onlyOnBigbox.service';
  import {
    getCategories,
    getFeaturedActivities,
  } from 'services/getCategories.service';

  import FeaturedBoxes from 'assets/graphql/queries/FeaturedBoxes.graphql';
  import GoogleClientID from 'assets/graphql/queries/account/GoogleClientID.graphql';
  import CartQuery from 'assets/graphql/queries/Cart.graphql';
  import CreditReference from 'assets/graphql/queries/CreditReference.graphql';

  import BbHorizontalSlider from 'common/components/BbHorizontalSlider';
  import ProductBlockSkeleton from 'common/components/ProductBlockSkeleton';
  import NewActivityBlock from 'common/components/NewActivityBlock';
  import BoxCard from 'common/components/BoxCard';

  import NewBoxBlock from 'components/NewBoxBlock';
  import NewPackageBlock from 'components/NewPackageBlock';
  import OptionCard from 'components/OptionCard';
  import HomeSlider from 'components/HomeSlider';
  import CardHome from 'components/Reminders/CardHome/CardHome.vue';
  import HomeCard from 'components/HomeCard';
  import NewsLetterSubscription from 'components/Travel/NewsLetterSubscription';
  import RefundCredits from 'components/Modals/RefundCredits/RefundCredits.vue';
  import CategoryCard from 'components/CategoryCard/CategoryCard.vue';

  import useAccount from 'composables/useAccount';

  @Component({
    apollo: {
      googleClientID: {
        query: GoogleClientID,
      },
      cart: {
        query: CartQuery,
      },
      featured_boxes: {
        query: FeaturedBoxes,
        result({ data: { featured_boxes } }) {
          this.featuredBoxList = featured_boxes.map(
            featureBox => featureBox.box,
          );
        },
      },
      user_credit: {
        query: CreditReference,
        skip() {
          return !this.$attrs?.authUser ;
        },
        result({ data: { user_credit } }) {
          this.creditReference = user_credit;
        },
      },
    },
    baseHeaderProps: {
      absolute: true,
    },
    components: {
      CategoryCard,
      BbHorizontalSlider,
      ProductBlockSkeleton,
      HomeSlider,
      OptionCard,
      NewActivityBlock,
      NewBoxBlock,
      NewPackageBlock,
      CardHome,
      HomeCard,
      NewsLetterSubscription,
      BoxCard,
      RefundCredits,
    },
    metaInfo() {
      const canonicalUrl = `${window.location.origin}${this.$route.path}`;

      // Define the domain
      const domain = window.location.host;

      let newtitle =
        'Bigbox: Regalos originales para toda ocasión. Sorprendé con experiencias únicas: gastronomía, relax, aventura, escapadas y mucho más.';

      return {
        title: newtitle,
        meta: [
          {
            property: 'og:title',
            content: newtitle,
            vmid: 'ogTitle',
          },
          {
            property: 'og:description',
            content: newtitle,
            vmid: 'ogDescription',
          },
          {
            property: 'og:url',
            content: window.location.origin,
            vmid: 'ogUrl',
          },
          { property: 'og:type', content: 'website', vmid: 'ogType' },
          {
            property: 'og:image',
            content: 'http://static.bigbox.com.ar/front/img/wishlist-share.png',
            vmid: 'ogImage',
          },
          {
            property: 'og:image:secure_url',
            content:
              'https://static.bigbox.com.ar/front/img/wishlist-share.png',
            vmid: 'ogSecureImage',
          },
        ],
        link: [
          {
            rel: 'canonical',
            href: canonicalUrl,
            vmid: 'canonical',
          },
          {
            rel: 'alternate',
            href: 'https://www.bigbox.com.ar/',
            hreflang: 'es-ar',
          },
          {
            rel: 'alternate',
            href: 'https://www.bigbox.com.pe/',
            hreflang: 'es-pe',
          },
          {
            rel: 'alternate',
            href: 'https://www.bigbox.cl/',
            hreflang: 'es-cl',
          },
          {
            rel: 'alternate',
            href: 'https://www.bigbox.com.uy/',
            hreflang: 'es-uy',
          },
          {
            rel: 'alternate',
            href: 'https://www.bigbox.com.mx/',
            hreflang: 'es-mx',
          },
          {
            rel: 'alternate',
            href: 'https://www.bigbox.com.co/',
            hreflang: 'es-co',
          },
          {
            rel: 'alternate',
            href: 'https://www.bigbox.es/',
            hreflang: 'es-es',
          },
        ],
      };
    },
    setup() {
      const {
        getUserData,
        getUserLogged,
        getUserIsBigboxPlus,
        loading,
        onUserStatus,
        onUserData,
      } = useAccount();

      return {
        getUserIsBigboxPlus,
        loggedUser: getUserLogged,
        auth_user: getUserData,
        loadingUser: loading,
        onUserStatus,
        onUserData,
      };
    },
  })
  export default class HomeViewComponent extends Vue {
    homeCards = [
      {
        title: `¿${this.$translate('Tenés')} un código Bigbox?`,
        description: `Si ${this.$translate(
          'tenés',
        )} un código de cualquiera de nuestros productos ${this.$translate(
          'ingresá',
        )} aquí para abrirlo.`,
        cta: 'Activar mi código',
        goTo: 'activate',
        icon: 'giftcard_2',
      },
      {
        title: '¿Cómo funciona?',
        description:
          'Te ayudamos a resolver dudas que puedas tener sobre nuestra web y cómo utilizarla.',
        cta: 'Ver como funciona',
        goTo: 'howItWorks',
        icon: 'question_2',
      },
    ];
    tld = getLastTld();
    featuredBoxList = [];
    creditReference = [];
    showReminderCard = false;
    mobileBussinessCardText = `${this.$translate('Conocé')} más`;
    desktopBussinessCardText = `Ver ${
      this.tld === 'pe' ? 'ventas' : 'soluciones'
    } corporativas`;
    categories = null;
    featuredActivities = null;
    onlyOnBigboxContent = [];
    async mounted() {
      this.categories = await getCategories();
      this.featuredActivities = await getFeaturedActivities();
      this.showReminderCard =
        !this.$attrs?.authUser?.has_created_three_reminders;
      this.onlyOnBigboxContent = await onlyOnBigBoxService.getOnlyInBigBox(
        8,
        1,
      );
    }

    initSignIn() {
      window.google.accounts.id.initialize({
        client_id: this.googleClientID,
        callback: response => {
          this.googleAuthCallback(response);
        },
      });

      window.google.accounts.id.renderButton(
        document.getElementById('gSignInButton'),
        {
          type: 'popup',
          text: 'sign_in_with',
          theme: 'outline',
          size: 'large',
          shape: 'pill',
        },
      );
      window.google.accounts.id.prompt();
    }

    fetchOnLogin() {
      this.onUserStatus();
      this.onUserData();
      this.$apollo.queries.cart.refetch();
    }

    googleAuthCallback(response) {
      if (response.error) {
        //eslint-disable-next-line
        console.log('Error:', response.error);
      } else {
        const body = { access_token: response.credential };
        requests
          .post('/api/v1/google-jwt-login/', body)
          .then(() => {
            this.fetchOnLogin();
          })
          .catch(error => {
            //eslint-disable-next-line
            console.error('Error:', error);
          });
      }
    }

    closeToolTip() {
      this.$store.setToolTipState(true);
      // eslint-disable-next-line no-undef
      ga('send', {
        hitType: 'event',
        eventCategory: 'PWA Prompt Installation',
        eventAction: 'closed in iOS',
        eventLabel: 'PWA prompt installation outcome',
      });
    }

    get showBBPlusBanner() {
      const isArgentina =
        getCountryNameFromTld(window.location.hostname) === 'Argentina';
      return isArgentina;
    }
    get bbPlusBanner() {
      return {
        title: this.getUserIsBigboxPlus
          ? 'Ya sos Bigbox+'
          : 'Ahora podés ser Bigbox+',
        subtitle: 'Más regalás, más disfrutás.',
        description:
          'Actividades exclusivas, crédito para seguir regalando y mucho más.',
        cta: 'Conocer más',
        ctaLandingSlug: this.getUserIsBigboxPlus
          ? 'bigbox-plus-activos'
          : 'bigbox-plus-no-activos',
      };
    }

    get corpoUrl() {
      return getCorpoUrl();
    }

    get toolTipState() {
      return this.$store.isToolTipClosed;
    }

    get isSafari() {
      const isSafari = !!navigator.userAgent.match(/Version\/[\d.]+.*Safari/);
      const iOS =
        /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      const isInStandaloneMode =
        'standalone' in window.navigator && window.navigator.standalone;
      return isSafari && iOS && !isInStandaloneMode;
    }
    redirectToFilters(categoryName) {
      this.$router.push({
        name: 'products',
        query: {
          card: 0,
          filters: JSON.stringify({ boxCategory: categoryName }),
        },
      });
    }

    openProductFilterView() {
      this.$router.push({ name: 'products', query: { card: 0 } });
    }
  }
</script>

<style lang="scss" scoped>
  @import '~assets/styles/index.scss';
  @import '~common/scss/typographies.scss';

  .home-view {
    position: relative;
    overflow-x: hidden;
    background-color: #fafafa;

    .home-slider-wrapper {
      width: 100%;
      margin: 0 auto;
      padding-bottom: 56px;

      @media (max-width: $screen-sm-min) {
        padding-bottom: 20px;
      }
    }

    @media (max-width: $screen-lg-max) {
      margin: 0 auto;
      padding-bottom: $BASE;
    }
  }

  .boxes-container {
    max-width: 1224px;
    margin-top: 20px;

    .boxes-title {
      display: block;
      margin: 32px 0 32px 8px;
      @media (max-width: $screen-sm) {
        display: flex;
        flex-direction: column;
        margin: 32px 0 16px 0;
      }
    }
  }

  .more-icon ::v-deep svg {
    height: 20px;
  }

  .tap-icon ::v-deep svg {
    height: 22px;
    margin: 0 3px;
  }

  .tooltip {
    background-color: white;
    position: sticky;
    z-index: 9999999999999;
    height: 70px;
    width: 100%;
    bottom: 10px;
    border-radius: 4px;
    box-shadow: 3px 3px 3px 3px rgba(0, 0, 0, 0.15);
  }

  .tip {
    position: relative;

    &:before {
      content: '';
      border-style: solid;
      border-width: 10px 15px 0px 15px;
      border-color: white transparent transparent transparent;
      position: absolute;
      top: 60px;
      left: 47%;
    }
  }

  .ex {
    color: $DARK-GRAY;
  }

  .home-title {
    font-size: 24px;
    color: $DARK-GRAY;

    @media (max-width: $screen-sm-min) {
      font-size: 22px;
      margin-bottom: 18px;
    }
  }

  .selector {
    box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.1);
    border-radius: 23.5px;
    height: 42px;

    p {
      color: $DARK-GRAY;
      width: max-content;
    }

    &.--active {
      border: 1px solid $PRIMARY;
    }
  }

  .see-all-button {
    height: 39px;
    width: 170px;
  }

  .cards-container {
    margin-bottom: 38px;

    @media (max-width: $screen-sm-min) {
      margin-bottom: $XLARGE;
    }

    .home-card {
      margin-right: 22px;

      @media (max-width: $screen-sm-min) {
        margin-right: 0;
        margin-bottom: $XLARGE;
      }

      &:last-child {
        margin-right: 0;

        @media (max-width: $screen-sm-min) {
          margin-bottom: 0;
        }
      }
    }
  }

  .skeleton-row {
    @media (max-width: $screen-sm-min) {
      width: 1000px;
    }

    @media (max-width: $screen-xs-min) {
      width: 1060px;
    }

    @media (max-width: 640px) {
      width: 880px;
    }

    .ProductBlockSkeleton {
      padding: 0 8px;

      @media (max-width: $screen-sm-min) {
        padding-left: 0;
        padding-right: 16px;
      }
    }
  }

  .corporate-card {
    background-size: contain;
    box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    height: 200px;
    margin-top: 26px;
    background-color: #ff8276;

    .corporate-card-column {
      background-color: #ff8276;
    }

    @media (max-width: $screen-sm-min) {
      padding: 16px 16px;
      margin-top: 48px;
    }

    h1 {
      font-size: 24px;

      @media (max-width: $screen-sm-min) {
        font-size: 18px;
      }
    }

    span {
      font-size: 16px;

      @media (max-width: $screen-sm-min) {
        font-size: 12px;
      }
    }

    a {
      color: $PRIMARY;
      border-radius: 4px;
      width: 268px;

      @media (max-width: $screen-sm-min) {
        width: 50%;
        margin-top: 8px;
      }
    }

    .corporate-card-description {
      max-width: 371px;
    }
  }

  .hands-icon {
    margin-right: 36px;

    @media (max-width: $screen-sm-min) {
      margin-right: 8px;
    }

    ::v-deep svg {
      height: 84px;

      @media (max-width: $screen-sm-min) {
        height: 51px;
      }
    }
  }

  .news-container {
    margin-top: 100px;
    margin-bottom: 100px;
  }

  .login-provider-google {
    position: absolute;
    top: $XXSMALL;
    right: $XXLARGE;
    z-index: $HEADER-Z-INDEX + 3;
    @media (max-width: $screen-xs-max) {
      right: 0;
      z-index: $HEADER-Z-INDEX - 3;
    }
  }

  .bb-plus-banner {
    height: 256px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: auto;
    margin-top: 48px;
    border-radius: 8px;
    overflow: hidden;
    background-color: $WHITE;
    border: 1px solid #fafafa;

    @media (max-width: $screen-sm-min) {
      flex-direction: column;
      height: 100%;
    }

    .img-container {
      width: 50%;
      min-width: 45%;
      height: 100%;
      position: relative;
      border-radius: 0 200px 200px 0;
      overflow: hidden;
      margin-right: 16px;

      @media (max-width: $screen-sm-min) {
        border-radius: 0;
        min-width: 100%;
        margin: 0;
        max-height: 220px;
      }

      .img {
        min-width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .bb-plus-logo {
        position: absolute;
        top: 50%;
        left: 46px;
        transform: translate(0, -50%);
        width: 141px;

        @media (max-width: $screen-sm-min) {
          width: 91px;
        }
      }
    }
    .content {
      display: flex;
      flex-direction: column;
      margin-right: 24px;

      @media (max-width: $screen-lg-min) {
        margin-right: 0;
        width: 100%;
        padding: 24px 16px 16px 16px;
      }

      .title {
        margin-bottom: 16px;
        color: $BBPLUS;
        @include typography-body-large;

        @media (max-width: $screen-sm-min) {
          @include typography-title-medium-1;
          margin-bottom: 8px;
        }
      }

      .subtitle {
        font-size: 18px;
        line-height: 22px;
        font-weight: 700;
        color: $DARK-GRAY;

        @media (max-width: $screen-sm-min) {
          @include typography-title-small;
        }
      }

      .description {
        font-size: 18px;
        line-height: 22px;
        color: $DARK-GRAY;

        @media (max-width: $screen-sm-min) {
          @include typography-body-small;
        }
      }

      .cta {
        max-width: max-content;
        padding: 14px 24px 14px 24px;
        margin-top: 16px;
        border-radius: 8px;
      }
    }
  }
</style>
